import { FC } from 'react';
import { Block } from '@ui-kit/Block';
import { useAppSelector } from '@redux/hooks';
import { declensionFactory } from '@helpers/declension';
import { getPriceFormat } from '@app/shared/helpers';
import { LinkButton } from '@ui-kit/LinkButton';
import { ButtonThemes } from '@app/shared';
import { BasketBriefTypeProps } from './TypeProps';
import { OrderingButton } from '@entities/Order';
import { TimeDeliveryPVZ, RegionCheck } from '@entities/Delivery';
import { getBasketData } from '@entities/Basket';
import { ButtonFastOrder, TypeTemplateFastOrder } from '@app/features/fastOrder';
import classNames from 'classnames';

import styles from './BasketBrief.module.scss';

const goodsDeclension = declensionFactory('товар', 'товара', 'товаров');

// TODO: перенести в widget

export const BasketBrief: FC<BasketBriefTypeProps> = ({ hideButton, inOrder, className }) => {
  const { totalSpecSum, totalSum, items } = useAppSelector(getBasketData);
  const { REGION: regionId } = useAppSelector(state => state.header.data.region);

  const orderSetСheck = () => {
    return items.filter(x => x.price > 0).length;
  };

  return (
    <>
      {totalSum !== 0 && totalSpecSum !== 0 && (
        <Block className={classNames(styles.Container, className)}>
          <h2 className={styles.Title}>Ваш заказ</h2>
          <div className={styles.CartPair}>
            <span>
              {orderSetСheck() + ' ' + goodsDeclension(orderSetСheck())}
              &nbsp; на сумму
            </span>
            <span>{getPriceFormat(totalSum) + ' ₽'}</span>
          </div>
          {totalSpecSum && totalSpecSum !== totalSum && (
            <div className={classNames(styles.CartPair, styles.Sale)}>
              <span>Скидка</span>
              <span>- {getPriceFormat(totalSum - totalSpecSum) + ' ₽'}</span>
            </div>
          )}
          <div className={styles.CartPair}>
            <span>Итого</span>
            <b className={styles.ResultPrice}>{' ' + getPriceFormat(totalSpecSum) + ' ₽'}</b>
          </div>
          {!hideButton && RegionCheck(parseInt(regionId)) && <TimeDeliveryPVZ regionId={parseInt(regionId)} />}
          {!hideButton && (
            <div className={styles.Buttons}>
              <LinkButton disabled={items.some(product => product.enabled === false)} data-testid="btn-design-order" fullWith href="/myorder">
                Оформить заказ
              </LinkButton>
              <ButtonFastOrder
                themes={ButtonThemes.Secondary}
                data-testid="btn-order-one"
                template={TypeTemplateFastOrder.orderOneClick}
                isProductsIsBasket={true}
                disabled={items.some(product => product.enabled === false)}
              >
                Заказать в 1 клик
              </ButtonFastOrder>
            </div>
          )}
          {inOrder && (
            <div className={styles.Buttons}>
              <OrderingButton />
            </div>
          )}
        </Block>
      )}
    </>
  );
};
